import React from 'react';
import PropTypes from 'prop-types';
import completedRenewalColumns from '../completed-renewals-columns';
import DataTablePagination from '../../../../widgets/data-table/DataTable/DataTablePagination/DataTablePagination';
import DataTable from '../../../../widgets/data-table/DataTable/DataTable';
import { Typography } from '@material-ui/core';
import { injectIntl } from 'react-intl';

const getColumns = (columns, sortRequest, sortBy) => [
  // Give the column header sort by functions.
  ...columns.map((column) => ({
    ...column,
    header: {
      ...column.header,
      onRequestSort: () =>
        column.header.sortBy ? sortRequest(column.header.sortBy) : () => {},
      isSortedBy: () => sortBy.name === column.header.sortBy
    }
  }))
];

const CompletedRenewalsTable = (props) => (
  <section className="data-tables">
    <div className="row">
      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 m-b-15">
        <Typography className="forms-table" component="h3" variant="subtitle1">
          {props.intl.formatMessage({
            id: 'completed_renewals'
          })}
        </Typography>

        <DataTable
          columns={getColumns(
            completedRenewalColumns(props),
            props.onRequestSort,
            props.sortBy
          )}
          bodyData={props.archivedRenewals}
          direction={props.sortBy.direction}
          footerContent={
            <DataTablePagination
              page={props.page}
              onChangePage={props.onChangePage}
              onChangeRowsPerPage={props.onChangeRowsPerPage}
            />
          }
        />
      </div>
    </div>
  </section>
);

CompletedRenewalsTable.propTypes = {
  archivedRenewals: PropTypes.array.isRequired,
  page: PropTypes.object.isRequired,
  onChangePage: PropTypes.func.isRequired,
  onChangeRowsPerPage: PropTypes.func.isRequired,
  sortBy: PropTypes.object.isRequired,
  onRequestSort: PropTypes.func.isRequired
};

export default injectIntl(CompletedRenewalsTable);
